const PAGE_TYPE = {
    H5: 1,
    PC: 10
};

function isPc() {
    let route = null;
    if (window.FEGORender) {
        const { store } = window.FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = window.FEGOEditor;
        route = project.route;
    }
    return route.now.pageType === PAGE_TYPE.PC;
}

function isEn() {
    let route = null;
    if (window.FEGORender) {
        const { store } = window.FEGORender;
        route = store.route;
    } else {
        const {
            app: { project }
        } = window.FEGOEditor;
        route = project.route;
    }
    return route.now.lang === 'EN';
}

function throttle(func, delay) {
    let prev = Date.now();
    return function () {
        let context = this;
        let args = arguments;
        let now = Date.now();
        if (now - prev >= delay) {
            func.apply(context, args);
            prev = Date.now();
        }
    };
}

export { isPc, isEn, throttle };
